export default __webpack_public_path__ + "static/media/P20008.38f6ce39.png";